import React, { lazy } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
// Minimal coordinate presence
const CoordinateGrid = () => <div className="absolute inset-0 w-full h-full opacity-[0.015] pointer-events-none" style={{
  backgroundImage: 'linear-gradient(#F5F5F5 0.5px, transparent 0.5px), linear-gradient(90deg, #F5F5F5 0.5px, transparent 0.5px)',
  backgroundSize: '80px 80px'
}} aria-hidden="true" data-id="element-525" />;
export function Careers() {
  return <>
      <Helmet data-id="element-526">
        <title data-id="element-527">Careers — Lazy Monk Labs</title>
        <meta name="description" content="We work with people who can lose everything without losing themselves. Building diagnostic systems for human patterns." data-id="element-528" />
        <meta name="robots" content="index, follow" data-id="element-529" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-530">
        {/* Navigation */}
        <header data-id="element-531">
          <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#2B2B2B]" data-id="element-532">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-533">
              <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-534">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jXd6KyuddrgAfqwwkkpUrR/Lazy_Monk_Labs_Logo.png" alt="Lazy Monk Labs Logo" className="h-8 w-auto" width="32" height="32" data-id="element-535" />
                <span className="text-base font-mono tracking-tight text-gray-400" data-id="element-536">
                  Lazy Monk Labs
                </span>
              </Link>
              <div className="flex items-center gap-8" data-id="element-537">
                <Link to="/work-mirror" className="text-sm text-[#F5F5F5] hover:text-gray-400 transition-colors font-medium" data-id="element-538">
                  Work Mirror
                </Link>
                <Link to="/decoder" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-539">
                  Decoder
                </Link>
                <Link to="/careers" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-540">
                  Careers
                </Link>
                <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-541">
                  Contact
                </a>
              </div>
            </div>
          </nav>
        </header>

        <main className="pt-24 pb-16" data-id="element-542">
          {/* 1. OPENING STATEMENT */}
          <section className="relative py-32 md:py-40 px-6 overflow-hidden" data-id="element-543">
            <CoordinateGrid data-id="element-544" />
            <div className="relative z-10 max-w-4xl mx-auto space-y-16" data-id="element-545">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif leading-[1.1] text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-546">
                We work with people who can lose everything without losing
                themselves.
              </h1>
            </div>
          </section>

          {/* 2. WHAT WE ARE BUILDING */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-547">
            <div className="max-w-4xl mx-auto space-y-12" data-id="element-548">
              <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-549">
                What we are building
              </h2>

              <div className="space-y-8 text-lg text-gray-400 leading-relaxed" data-id="element-550">
                <p data-id="element-551">
                  Lazy Monk Labs is building diagnostic systems for human
                  patterns.
                </p>
                <p data-id="element-552">
                  Products like Decoder and Conscious OS treat the human mind
                  like an operating system — something that can be diagnosed,
                  understood, and re-architected.
                </p>
                <p className="text-[#F5F5F5] pt-6 border-t border-[#2B2B2B]" data-id="element-553">
                  We are not building a company. We are building a
                  civilization-grade system for how humans understand themselves
                  and their patterns.
                </p>
              </div>
            </div>
          </section>

          {/* 3. THE MISSION */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-554">
            <div className="max-w-4xl mx-auto space-y-12" data-id="element-555">
              <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-556">
                The mission
              </h2>

              <div className="space-y-8 text-lg text-gray-400 leading-relaxed" data-id="element-557">
                <p data-id="element-558">The world runs on broken mental operating systems.</p>
                <p data-id="element-559">
                  Most suffering, bad decisions, bad leadership, and bad
                  organizations come from undiagnosed inner systems.
                </p>
                <p className="text-[#F5F5F5]" data-id="element-560">
                  Lazy Monk Labs is building the diagnostic and engineering
                  layer for human consciousness.
                </p>
              </div>
            </div>
          </section>

          {/* 4. THE BUILDER'S RESILIENCE FILTER */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-561">
            <div className="max-w-4xl mx-auto space-y-16" data-id="element-562">
              <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-563">
                What we look for
              </h2>

              <div className="space-y-12" data-id="element-564">
                {/* Capacity to Bet */}
                <div className="space-y-4" data-id="element-565">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-566">
                    Capacity to Bet
                  </h3>
                  <p className="text-lg text-gray-400 leading-relaxed" data-id="element-567">
                    You've chosen uncertainty over comfort at least once in your
                    life.
                  </p>
                </div>

                {/* Ego Containment */}
                <div className="space-y-4" data-id="element-568">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-569">
                    Ego Containment
                  </h3>
                  <p className="text-lg text-gray-400 leading-relaxed" data-id="element-570">
                    You can admit when you're wrong without protecting your
                    identity.
                  </p>
                </div>

                {/* Regenerative Confidence */}
                <div className="space-y-4" data-id="element-571">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-572">
                    Regenerative Confidence
                  </h3>
                  <p className="text-lg text-gray-400 leading-relaxed" data-id="element-573">
                    You trust your ability to rebuild more than any single
                    outcome.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 5. WHO SHOULD APPLY (AND WHO SHOULDN'T) */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-574">
            <div className="max-w-4xl mx-auto" data-id="element-575">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-576">
                {/* This is not for */}
                <div className="space-y-8" data-id="element-577">
                  <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-578">
                    This is not for people who
                  </h2>
                  <div className="space-y-4 text-gray-500" data-id="element-579">
                    <p data-id="element-580">• Want safety-first careers</p>
                    <p data-id="element-581">• Need structure before responsibility</p>
                    <p data-id="element-582">• Want a brand name more than a mission</p>
                    <p data-id="element-583">• Want to be told what to do</p>
                  </div>
                </div>

                {/* This is for */}
                <div className="space-y-8" data-id="element-584">
                  <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-585">
                    This is for people who
                  </h2>
                  <div className="space-y-4 text-gray-400" data-id="element-586">
                    <p data-id="element-587">• Want to build something that didn't exist before</p>
                    <p data-id="element-588">• Are comfortable with ambiguity and first principles</p>
                    <p data-id="element-589">
                      • Want their work to matter at a civilizational, not
                      cosmetic, level
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 6. WHAT WE ARE NOT */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-590">
            <div className="max-w-4xl mx-auto space-y-8" data-id="element-591">
              <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-592">
                What we are not
              </h2>

              <div className="space-y-4 text-lg text-gray-500" data-id="element-593">
                <p data-id="element-594">• Not a self-help company</p>
                <p data-id="element-595">• Not a coaching business</p>
                <p data-id="element-596">• Not an astrology or spirituality brand</p>
                <p data-id="element-597">• Not a motivational content company</p>
              </div>

              <p className="text-lg text-[#F5F5F5] pt-6 border-t border-[#2B2B2B]" data-id="element-598">
                We are building diagnostic systems. Calm. Precise. Serious.
              </p>
            </div>
          </section>

          {/* 7. CALL TO ACTION */}
          <section className="py-32 px-6 relative overflow-hidden border-t border-[#2B2B2B]" data-id="element-599">
            <CoordinateGrid data-id="element-600" />
            <div className="relative z-10 max-w-4xl mx-auto space-y-12" data-id="element-601">
              <div className="space-y-8" data-id="element-602">
                <p className="text-xl md:text-2xl text-gray-400 leading-relaxed" data-id="element-603">
                  We are not running a hiring process.
                  <br data-id="element-604" />
                  We are assembling a very small group of builders.
                </p>

                <p className="text-lg text-[#F5F5F5] leading-relaxed pt-6 border-t border-[#2B2B2B]" data-id="element-605">
                  If you read this and felt a quiet "yes" — write to:{' '}
                  <a href="mailto:anish@lazymonklabs.com" className="underline hover:text-gray-400 transition-colors" data-id="element-606">
                    anish@lazymonklabs.com
                  </a>
                </p>
              </div>

              <div className="pt-8 space-y-6 text-base text-gray-500 leading-relaxed border-t border-[#2B2B2B]" data-id="element-607">
                <p className="text-[#F5F5F5]" data-id="element-608">Don't send a resume.</p>
                <p data-id="element-609">Send a note about:</p>
                <div className="space-y-3 pl-6" data-id="element-610">
                  <p data-id="element-611">• What you've built</p>
                  <p data-id="element-612">• What you've broken</p>
                  <p data-id="element-613">• What you've rebuilt</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        {/* Footer */}
        <footer className="py-12 px-6 border-t border-[#2B2B2B]" data-id="element-614">
          <div className="max-w-6xl mx-auto" data-id="element-615">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8" data-id="element-616">
              <div data-id="element-617">
                <p className="text-sm text-gray-500 font-mono" data-id="element-618">
                  Lazy Monk Labs
                </p>
                <p className="text-xs text-gray-600 mt-1" data-id="element-619">
                  Pattern recognition systems
                </p>
              </div>

              <div className="flex gap-8 text-sm text-gray-500" data-id="element-620">
                <Link to="/work-mirror" className="hover:text-[#F5F5F5] transition-colors" data-id="element-621">
                  Work Mirror
                </Link>
                <Link to="/decoder" className="hover:text-[#F5F5F5] transition-colors" data-id="element-622">
                  Decoder
                </Link>
                <Link to="/careers" className="hover:text-[#F5F5F5] transition-colors" data-id="element-623">
                  Careers
                </Link>
                <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="hover:text-[#F5F5F5] transition-colors" data-id="element-624">
                  Contact
                </a>
              </div>

              <div className="text-xs text-gray-600 font-mono" data-id="element-625">
                © {new Date().getFullYear()}
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>;
}